"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactJss = _interopRequireWildcard(require("react-jss"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var _globalPadding;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var colors = {
  primary: "#f15953",
  primaryDark: "#d24f45",
  primaryGlow: "#d24f45",
  // todo
  secondary: "#55c3ba",
  secondaryDark: "#44b0a7",
  tertiary: "#2e7fc2",
  quaternary: "#ffc629",
  white: "#fff",
  gray050: "#fbfcfd",
  gray100: "#edf1f4",
  gray200: "#dde2e7",
  gray300: "#ccd2d8",
  gray400: "#b3bac1",
  gray500: "#888f96",
  gray600: "#60686f",
  gray700: "#4b565f",
  gray800: "#5a5b5c",
  gray900: "#232c35",
  black: "#11181e",
  error: "#9c2929",
  facebook: "#3b5998",
  google: "#db4437",
  linkedin: "#007bb5",
  pinterest: "#bd081c",
  twitter: "#1da1f2"
};
var alertColors = {
  error: {
    color: "#9c2929",
    backgroundColor: "#fcf2f2",
    borderColor: "#f6dddd"
  },
  info: {
    color: "#0c5460",
    backgroundColor: "#d1ecf1",
    borderColor: "#bee5eb"
  },
  success: {
    color: "#246761",
    backgroundColor: "#ecf8f7",
    borderColor: "#d2e8e6"
  },
  warning: {
    color: "#856404",
    backgroundColor: "#fff3cd",
    borderColor: "#ffeeba"
  }
};
var typography = {
  bodyColor: "#2E2E35",
  fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  fontSize: "1rem"
};
var transitions = {
  default: "all 200ms linear"
};
var breakpoints = {
  600: "@media (min-width: 600px)",
  900: "@media (min-width: 900px)",
  1200: "@media (min-width: 1200px)",
  tabletPortrait: "@media (min-width: 600px)",
  // todo: deprecate (check existing code for usage)
  tabletLandscape: "@media (min-width: 900px)",
  // todo: deprecate (check existing code for usage)
  desktop: "@media (min-width: 1200px)" // todo: deprecate (check existing code for usage)

};
var globalBorderRadius = "4px";
var globalBoxShadow = "0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12)";
var globalPadding = (_globalPadding = {
  padding: "12px"
}, _defineProperty(_globalPadding, breakpoints.tabletPortrait, {
  padding: "16px"
}), _defineProperty(_globalPadding, breakpoints.tabletLandscape, {
  padding: "20px"
}), _defineProperty(_globalPadding, breakpoints.desktop, {
  padding: "24px"
}), _globalPadding);
var defaultTheme = {
  alertColors: alertColors,
  breakpoints: breakpoints,
  colors: colors,
  globalBorderRadius: globalBorderRadius,
  globalBoxShadow: globalBoxShadow,
  globalPadding: globalPadding,
  transitions: transitions,
  typography: typography
};
var GlobalsAndReset = (0, _reactJss.default)(function (theme) {
  return {
    "@global": {
      /* Eric Meyer Reset v2.0 */

      /* https://meyerweb.com/eric/tools/css/reset/ */
      "html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video": {
        margin: "0",
        padding: "0",
        border: "0",
        fontSize: "100%",
        font: "inherit",
        verticalAlign: "baseline"
      },
      "article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section": {
        display: "block"
      },
      body: {
        lineHeight: "1"
      },
      "ol, ul": {
        listStyle: "none"
      },
      "blockquote, q": {
        quotes: "none"
      },
      "blockquote:before, blockquote:after, q:before, q:after": _defineProperty({
        content: "''"
      }, "content", "none"),
      table: {
        borderCollapse: "collapse",
        borderSpacing: "0"
      },

      /* Globals */
      "html, body": {
        width: "100%",
        minHeight: "100%",
        fontFamily: theme.typography.fontFamily || "sans-serif",
        fontSize: theme.typography.fontSize || "1rem",
        fontWeight: "500",
        color: theme.typography.bodyColor || "#000",
        backgroundColor: "#fafafa",
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        margin: "0",
        padding: "0"
      },

      /* Box-sizing border-box */

      /* https://www.paulirish.com/2012/box-sizing-border-box-ftw/ */
      html: {
        boxSizing: "border-box",
        background: "transparent"
      },
      "*, *:before, *:after": {
        boxSizing: "inherit"
      },

      /* Reset `button` to nothing */

      /* https://gist.github.com/chrisheninger/a860f87ef4e529b2df606768b97665a8 */
      button: {
        display: "inline-block",
        "-webkit-appearance": "none",
        "-moz-appearance": "none",
        userSelect: "none",
        textDecoration: "none",
        fontFamily: "inherit",
        fontSize: "inherit",
        color: "inherit",
        cursor: "pointer",
        border: "none",
        backgroundColor: "transparent",
        borderColor: "transparent",
        padding: "0",
        margin: "0",
        "&:disabled": {
          opacity: 0.6,
          cursor: "not-allowed"
        }
      }
    }
  };
})(function (_ref) {
  var children = _ref.children;
  return children;
});

var ThemeProvider = function ThemeProvider(_ref2) {
  var children = _ref2.children,
      theme = _ref2.theme,
      _ref2$withReset = _ref2.withReset,
      withReset = _ref2$withReset === void 0 ? true : _ref2$withReset,
      rest = _objectWithoutProperties(_ref2, ["children", "theme", "withReset"]);

  var mergedTheme = theme ? (0, _merge.default)(defaultTheme, theme) : defaultTheme;
  return _react.default.createElement(_reactJss.ThemeProvider, _extends({
    theme: mergedTheme
  }, rest), withReset ? _react.default.createElement(GlobalsAndReset, null, children) : children);
};

var _default = ThemeProvider;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/elevate-ui/ThemeProvider/index.js
// module id = 1878
// module chunks = 114276838955818